<template>
  <v-card>
    <v-card-title><h2 class="text-h4">{{$t('webboxes.shopify.title')}}</h2></v-card-title>
    <v-card-text>
    <!-- instructions from https://shopify.dev/apps/store/requirements>
If your app includes app blocks or app embed blocks, then include detailed setup instructions within the user interface of your app. Include the following content:

An overview of the app blocks and app embed blocks that are in your app, and their purpose
How to configure functional settings for the app blocks and app embed blocks
Which templates app blocks and app embed blocks can be added to
How to add, remove, and reorder app blocks
How to activate and deactivate app embed blocks
-->
<!--
    TODO add support for vintage themes?
-->

    <p>{{ $t('webboxes.shopify.intro') }}</p>
    <p>{{ $t('webboxes.shopify.boxtypes') }}</p>
    <p>{{ $t('webboxes.shopify.themes') }}</p>
    <v-select :label="$t('webboxes.shopify.theme')" :items="themes" v-model="theme" :loading="themes.length  == 0" item-text="name" item-value="id" return-object />
    <template v-if="theme">
    <v-alert type="success" colored-border border="left" v-if="theme.sections == 'full'">
        {{ $t('webboxes.shopify.support.full') }}
    </v-alert>
    <v-alert type="warning" colored-border border="left" v-if="theme.sections == 'partial'">
        {{ $t('webboxes.shopify.support.partial') }}
    </v-alert>
    <v-alert type="error"  colored-border border="left" v-if="theme.sections == 'none'">
        {{ $t('webboxes.shopify.support.none') }}
    </v-alert>
    </template>
    
    <v-btn color="primary" :href="editorurl" target="_blank">{{ $t('webboxes.shopify.themeEditorButton') }}</v-btn>
    <div class="mt-3" v-if="theme && theme.sections != 'none'"><iframe width="800" height="450" :src="shopifyBoxesVideoOS2" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe></div>
    </v-card-text>
    
    </v-card>
    
</template>

<script>

import { mapState, mapGetters } from 'vuex'

export default {
    name: 'WebboxCodeShopify',
    props: { customCss: Boolean, js: String, css: String, box: String },
    data() {
        return {
            tab: null,
            themes: [],
            theme: null
        }
    },
    watch: {
        item() {
            this.loadThemes();
        }
    },
    computed: {
        editorurl() {
            // ugly but needed...
            let template = this.box;
            if(template == 'home') {
                template = 'index';
            }
            return `https://${this.item?.productFeedURL}/admin/themes/${this.theme?.id ?? 'current'}/editor?template=${template}`;
        },
        supported() {
            return this.theme && this.theme.sections == 'full'
        },
        ...mapState('domains', ['item']),
        ...mapGetters('ui', ['shopifyBoxesVideoOS2'])
    },
    methods: {
        async loadThemes() {
            if(!this.item) {
                return;
            }
            this.themes = await this.$store.dispatch('domains/shopifyGetThemes', { id: this.item.id });
            this.theme = this.themes.find(t => t.role == 'main');
        }
    },
    created() {
        this.loadThemes();
    }
}
</script>

<style>

</style>